import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsWhenMultipleTagsExist",
    title: "Auto Tag Products When Multiple Tags Exist",
    description: "Automatically tag products when multiple selected tags exist. Supports matching All, Any, or None of the required tags.",
    example: "",
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsWhenMultipleTagsExist",
                requiredTags: [],
                tagMatchCondition: "All",
                tagsToAdd: [],
                productStatuses: ["DRAFT", "ARCHIVED", "ACTIVE"],
                removeTagsIfRequiredTagIsMissing: true,
                skipAddTagsIfAlreadyAdded: true,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (!rule.settings.requiredTags || rule.settings.requiredTags.length === 0 ||
                        (rule.settings.requiredTags.length === 1 && rule.settings.requiredTags[0] === "")) {
                        errors["requiredTags"] = "At least one required tag must be specified";
                    }
                },
            ], null);
    }
};

export default ruleDefinition;
